// extracted by css-extract-rspack-plugin
export default {"assignYourselfButton":"AssignYourself-module__assignYourselfButton__BMUw1"};